<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <v-card>
                <v-card-text>
                    <h1>Price List</h1>
                    <hr>

                    <v-layout>
                        <v-flex>
                            <v-btn @click="getProd">Show Products</v-btn>
                        </v-flex>
                    </v-layout>
                    <div v-if="showListProd">
                        <hr>
                        <v-layout pt-2 pb-2 indigo lighten-4>
                            <v-flex xs1 pl-1><h4>No</h4></v-flex>
                            <v-flex xs3><h4>Code</h4></v-flex>
                            <v-flex xs5 pl-1><h4>Name</h4></v-flex>
                            <v-flex xs4 text-xs-right><h4>Price</h4></v-flex>
                        </v-layout>
                        <hr>
                        <v-layout v-for="(item,i) in listProd" :key="i">
                            <v-flex xs1 pl-2 mt-4><font size=4>{{i+1}}</font></v-flex>
                            <v-flex xs3 mr-3>
                                <v-text-field v-model="item.Code" readonly tabindex="-1"></v-text-field>
                            </v-flex>
                            <v-flex xs5 mr-3>
                                <v-text-field v-model="item.NameMM" readonly tabindex="-1"></v-text-field>
                            </v-flex>
                            <v-flex xs4 my-4>
                                <font size=3>
                                    <vue-numeric separator="," :precision="2" v-model="item.PriceMM" class="line"></vue-numeric>
                                </font>
                            </v-flex>
                        </v-layout>
                        <hr>
                        <br>
                        <v-layout>
                            <v-flex text-xs-center>
                                <v-btn @click="updateProd">save</v-btn>
                                <v-btn @click="cancel">cancel</v-btn>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'
import VueNumeric from 'vue-numeric'
export default {
    components: {
        mainMenu,
        VueNumeric
    },
    data(){
        return{
            showListProd: false,
            listProd: [],
        }
    },
    methods:{
        getProd(){
            this.listProd = []
            db.collection("code").doc("productcode").collection("proCode").orderBy("Code", "asc").get()
            // db.collection("code").doc("productcode").collection("proCode").orderBy("Code", "asc").limit(4).get()
            .then(snapshot=>{
                snapshot.forEach(doc=>{
                    this.listProd.push(doc.data())
                })
                this.showListProd = true
            })
        },
        updateProd(){
            this.listProd.forEach(rec=>{
                db.collection("code").doc("productcode").collection("proCode").where("Code", "==", rec.Code).get()
                .then(querySnapshot=> {
                    let idProd = querySnapshot.docs[0].id
                    // console.log(idProd)
                    db.collection("code").doc("productcode").collection("proCode").doc(idProd).update({
                        Code: rec.Code,
                        NameMM: rec.NameMM,
                        PriceMM: rec.PriceMM
                    })
                    .catch(error=>{
                        alert("Error getting documents: ", error)
                    })
                })
                .catch(error=>{
                    console.log("Error getting documents: ", error)
                })
            })
            this.$nextTick(()=>{
                alert("Successfully.")
            })
        },
        cancel(){
            this.showListProd = false
            this.listProd = []
        }
    },
}
</script>
<style scoped>
.collapse:nth-child(even){
    background-color: #dddddd;
}
.line{
    border-bottom: 1px solid gray;
    text-align: right;
    width: 100%;
}
</style>